import { t } from '@lingui/core/macro';
import { addDays, addMonths, addWeeks, isValid } from 'date-fns';
export const getDueDaysPresets = (dueDate) => {
    if (!isValid(dueDate)) {
        return [];
    }
    const items = [
        {
            date: 'one-day',
            check: dueDate > addDays(new Date(), 1),
            label: t({ comment: 'Tasks reminder - 1 day before due date', message: '1 day before due date' }),
        },
        {
            date: 'two-days',
            check: dueDate > addDays(new Date(), 2),
            label: t({ comment: 'Tasks reminder - 2 days before due date', message: '2 days before due date' }),
        },
        {
            date: 'two-weeks',
            check: dueDate > addWeeks(new Date(), 2),
            label: t({ comment: 'Tasks reminder - 2 weeks before due date', message: '2 weeks before due date' }),
        },
        {
            date: 'one-month',
            check: dueDate > addMonths(new Date(), 1),
            label: t({ comment: 'Tasks reminder - 1 month before due date', message: '1 month before due date' }),
        },
    ];
    return items.filter((item) => item.check);
};
